var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDialerMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 109 109"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 54.5,
    r: 51.5,
    fill: "#FFF",
    stroke: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    fillRule: "nonzero",
    d: "M67.803 54.837a1.079 1.079 0 10-2.158 0c0 6.545-5.324 11.869-11.869 11.869-2.656 0-5.11-.877-7.09-2.357l2.697-3.372a7.512 7.512 0 004.393 1.413c4.165 0 7.553-3.388 7.553-7.553v-8.792l6.237-7.797a1.079 1.079 0 00-1.685-1.348l-4.552 5.69v-.7c0-4.165-3.388-7.553-7.553-7.553-4.164 0-7.552 3.388-7.552 7.553v12.947c0 1.748.596 3.358 1.596 4.64l-2.741 3.426a11.823 11.823 0 01-3.171-8.066 1.079 1.079 0 00-2.158 0c0 3.793 1.514 7.239 3.969 9.766l-3.733 4.665a1.079 1.079 0 001.685 1.349l3.667-4.583a13.95 13.95 0 007.36 2.788v4.357H49.46a1.079 1.079 0 000 2.158h8.631a1.079 1.079 0 100-2.158h-3.237v-4.357c7.232-.552 12.948-6.614 12.948-13.985zm-8.632 0a5.4 5.4 0 01-5.395 5.395 5.364 5.364 0 01-3.043-.943l8.438-10.547v6.095zm-10.79 0V41.89a5.4 5.4 0 015.395-5.395 5.4 5.4 0 015.395 5.395v3.398l-9.949 12.436a5.36 5.36 0 01-.84-2.887z"
  }))));
}

export default SvgDialerMute;